export default __webpack_public_path__ + "static/media/functions_openapi.f50fb041.yaml";